import { getNumberLocale } from './locale';

/** 1000000 -> 1 000 000 ( разделяем пробелом каждые N разрядов )*/
export const toHumanReadableFormat = (raw: number): string => {
  return new Intl.NumberFormat(getNumberLocale()).format(raw);
};
